import React from "react";
import BannerImage from "../../gallery/banner.jpg";
import { Search } from "react-bootstrap-icons";
import SelectCustom from "./SelectCustom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";

// Add CSS animation for skeleton pulse effect
const skeletonStyle = `
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }
`;

// Inject the animation CSS
if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = skeletonStyle;
  document.head.appendChild(styleSheet);
}
const Banner = React.memo(function Banner() {
  let categorySelectedOption = {
    label: "What are you looking for?",
    value: 1,
  };
  let locationSelectedOption = {
    label: "Chose your location",
    value: 1,
  };
  const history = useHistory();

  const { data: categories, isLoading: categoriesLoading } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const response = await axios.request({
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/categories",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          page: 1,
          limit: 300,
        },
      });
      return response.data.data;
    },
  });

  const { data: locations, isLoading: locationsLoading } = useQuery({
    queryKey: ["locations"],
    queryFn: async () => {
      const response = await axios.request({
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/locations",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          page: 1,
          limit: 300,
        },
      });
      return response.data.data;
    },
  });
  const handleRedirect = (event) => {
    event.preventDefault();
    let category_id = 1; //document.getElementById('category_select').title;
    let location_id = 1; //document.getElementById('location_select').title;
    var catSelect = document.getElementById("category_select");
    if (catSelect.title !== "") {
      category_id = catSelect.title;
    }

    var locSelect = document.getElementById("location_select");
    if (locSelect.title !== "") {
      location_id = locSelect.title;
    }
    history.push(`/search?category=${category_id}&location=${location_id}&page=1&limit=10`);
  };

  return (
    <>
      <div className="container-fluid">
        <section className="hero hero--video">
          <div className="container">
            <div className="col-12">
              <div className="search">
                <div className="d-flex justify-content-center">
                  <h6 className="banner-text-1">जे खोजिन्छ, मज्जाले भेटिन्छ</h6>
                </div>
                <div className="d-flex justify-content-center">
                  <h6 className="banner-text-2">The right way to find the localised Nepalese services in the UK</h6>
                </div>
                <div className="row d-flex justify-content-center">
                  <div className="col-lg-3 col-md-3 col-12 category-select">
                    {categoriesLoading ? (
                      <div
                        style={{
                          height: "38px",
                          border: "1px solid #ced4da",
                          borderRadius: "0.375rem",
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          padding: "0.375rem 0.75rem",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div
                            style={{
                              height: "1.2em",
                              backgroundColor: "#f0f0f0",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            width: "0",
                            height: "0",
                            borderLeft: "0.3em solid transparent",
                            borderRight: "0.3em solid transparent",
                            borderTop: "0.3em solid #495057",
                            marginLeft: "auto",
                          }}
                        ></div>
                      </div>
                    ) : (
                      categories && (
                        <SelectCustom
                          id={"category_select"}
                          //placeHolder='e.g. Plumber, Electrician'
                          options={categories}
                          selectedOption={categorySelectedOption}
                        />
                      )
                    )}
                  </div>
                  <div className="col-lg-3 col-md-3 col-12 location-select">
                    {locationsLoading ? (
                      <div
                        style={{
                          height: "38px",
                          border: "1px solid #ced4da",
                          borderRadius: "0.375rem",
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          padding: "0.375rem 0.75rem",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div
                            style={{
                              height: "1.2em",
                              backgroundColor: "#f0f0f0",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            width: "0",
                            height: "0",
                            borderLeft: "0.3em solid transparent",
                            borderRight: "0.3em solid transparent",
                            borderTop: "0.3em solid #495057",
                            marginLeft: "auto",
                          }}
                        ></div>
                      </div>
                    ) : (
                      locations && (
                        <SelectCustom
                          id={"location_select"}
                          //placeHolder='Town or City'
                          options={locations}
                          selectedOption={locationSelectedOption}
                        />
                      )
                    )}
                  </div>
                  <div className="col-lg-2 col-md-2 col-12">
                    {categoriesLoading || locationsLoading ? (
                      <div
                        style={{
                          height: "38px",
                          backgroundColor: "#dc3545",
                          border: "1px solid #dc3545",
                          borderRadius: "0.375rem",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          animation: "pulse 1.5s ease-in-out infinite",
                          marginTop: "4px",
                        }}
                      >
                        <div
                          style={{
                            width: "16px",
                            height: "16px",
                            backgroundColor: "rgba(255,255,255,0.3)",
                            borderRadius: "50%",
                            marginRight: "8px",
                          }}
                        ></div>
                        <div
                          style={{
                            height: "1em",
                            width: "40px",
                            backgroundColor: "rgba(255,255,255,0.3)",
                            borderRadius: "4px",
                          }}
                        ></div>
                      </div>
                    ) : (
                      <button onClick={handleRedirect} className="btn-search-danger">
                        <Search size={15} style={{ marginRight: "5px" }} />
                        Search
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img className="d-lg-block" src={BannerImage} alt="Banner" style={{ opacity: "0.3" }} loading="lazy" />
        </section>
      </div>
    </>
  );
});

export default Banner;
